import React from 'react';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';

/**
 * Interface pour les props du composant ContractStatusBadge
 */
interface ContractStatusBadgeProps {
  envelope?: CRM.DocusignEnvelope | undefined;
  oneFlowContract?: CRM.OneFlowContract | undefined
}

const badges: Record<'sent' | 'completed', React.ReactElement> = {
  sent: (
      <b title='E-CONTRAT NON SIGNÉ'>
      <AssignmentLateIcon style={{ fontSize: "32px", color: '#ff7734' }} />
    </b>
  ),
  completed: (
    <b title='E-CONTRAT SIGNÉ'>
    <AssignmentTurnedInIcon style={{ fontSize: "32px", color: '#6BCE34' }} />
  </b>
  ),
  
};

/**
 * Composant d'affichage du statut des contrats électroniques
 * 
 * Ce composant affiche visuellement le statut d'un contrat :
 * - Icône orange avec titre "E-CONTRAT NON SIGNÉ" si le contrat est envoyé mais non signé
 * - Icône verte avec titre "E-CONTRAT SIGNÉ" si le contrat est complété/signé
 * 
 * Logique métier :
 * - Support des contrats DocuSign et OneFlow
 * - Priorité au statut DocuSign si disponible
 * - Fallback sur OneFlow si DocuSign n'est pas disponible
 * - Statut par défaut "sent" si aucun contrat n'est fourni
 * 
 * @param envelope Enveloppe DocuSign (optionnelle)
 * @param oneFlowContract Contrat OneFlow (optionnel)
 * @returns Composant React affichant le statut du contrat
 */
export function ContractStatusBadge({ envelope, oneFlowContract }: ContractStatusBadgeProps) {
  const status = envelope ? (envelope.status !== 'completed' ? 'sent' : 'completed') : 
    oneFlowContract ? oneFlowContract.state !== 'signed' ? 'sent' : 'completed' : 'sent';

  return badges[status];
}
